/* Atalhos de tipo de camisa da colecao (ver snippets/md-atalhos-tipo.liquid).
 *
 * Um tipo por vez: tocar numa pilula tira as outras pilulas ativas e aplica a
 * dela; tocar na ativa so a desmarca. Filtro que nao tem pilula (tamanho, time,
 * Men...) fica como esta. Quem aplica e o proprio facets.js (renderPage), o
 * mesmo caminho dos filtros da lateral: grade, lateral e URL andam juntas.
 *
 * O AJAX troca o #ProductGridContainer inteiro, e com ele a faixa; por isso o
 * clique e escutado no document e a posicao da faixa e guardada e devolvida
 * depois da troca. Desde 2026-10-23 a faixa desliza tambem no computador, e o
 * mouse pode arrasta-la (bloco "Arrastar a faixa com o mouse", abaixo).
 *
 * O meio botao cortado e o esmaecido valem para TODA faixa [data-md-tipos] da
 * pagina, inclusive a da vitrine do time na PDP (2026-10-22). O clique, nao:
 * faixa dentro de [data-md-tipos-local] tem dono proprio (md-vitrine-time.js)
 * e este arquivo nao mexe nela.
 */
(function () {
  "use strict";

  var rolagem = 0;

  function formulario() {
    return window.customElements && window.customElements.get("facet-filters-form");
  }

  function semPar(params, nome, valor) {
    var novos = new URLSearchParams();
    params.forEach(function (v, k) {
      if (!(k === nome && v === valor)) novos.append(k, v);
    });
    return novos;
  }

  /* Meio botao cortado (pedido do Ivan em 2026-10-22): SO quando as pilulas
   * nao cabem na faixa. Testa o respiro lateral dentro da faixa abaixo e fica
   * com o que deixa a pilula da borda direita mais perto de metade visivel,
   * desempatando pelo mais proximo do padrao. Cabendo, a variavel sai e nada
   * muda. Desde 2026-10-23 a faixa do computador tambem desliza (pedido do
   * Ivan), com o padrao de 16px e um minimo maior que o do celular, porque
   * a letra ali e maior. */
  var CELULAR = "(max-width: 749px)";
  var PAD = {
    celular: { padrao: 14, min: 9, max: 20 },
    computador: { padrao: 16, min: 12, max: 22 }
  };

  function meioCorte(trilho) {
    trilho.style.removeProperty("--md-tipos-pad");
    var cs = getComputedStyle(trilho);
    if (cs.flexWrap !== "nowrap") return;
    if (trilho.scrollWidth <= trilho.clientWidth + 1) return;
    var faixa = window.matchMedia && window.matchMedia(CELULAR).matches ? PAD.celular : PAD.computador;
    var PAD_PADRAO = faixa.padrao;
    var PAD_MIN = faixa.min;
    var PAD_MAX = faixa.max;

    var gap = parseFloat(cs.columnGap) || 0;
    var inicio = parseFloat(cs.paddingLeft) || 0;
    var borda = trilho.clientWidth;
    var miolos = [];
    var pilulas = trilho.querySelectorAll(".md-tipos__pilula");
    for (var i = 0; i < pilulas.length; i++) {
      var ps = getComputedStyle(pilulas[i]);
      miolos.push(pilulas[i].getBoundingClientRect().width - parseFloat(ps.paddingLeft) - parseFloat(ps.paddingRight));
    }

    var melhor = null;
    for (var pad = PAD_MIN; pad <= PAD_MAX; pad += 0.5) {
      var x = inicio;
      var fracao = null;
      for (var j = 0; j < miolos.length; j++) {
        var w = miolos[j] + 2 * pad;
        if (x + w > borda) {
          fracao = Math.max(0, (borda - x) / w);
          break;
        }
        x += w + gap;
      }
      if (fracao === null) continue; /* com esse respiro tudo caberia: nao serve */
      var nota = Math.abs(fracao - 0.5) + Math.abs(pad - PAD_PADRAO) * 0.002;
      if (!melhor || nota < melhor.nota) melhor = { pad: pad, nota: nota };
    }
    if (melhor && melhor.pad !== PAD_PADRAO) trilho.style.setProperty("--md-tipos-pad", melhor.pad + "px");
  }

  function marcarBordas(trilho) {
    var resto = trilho.scrollWidth - trilho.clientWidth - trilho.scrollLeft;
    trilho.classList.toggle("md-tipos__trilho--antes", trilho.scrollLeft > 2);
    trilho.classList.toggle("md-tipos__trilho--depois", resto > 2);
  }

  /* A faixa da colecao nasce de novo a cada AJAX: a posicao dela mora em `rolagem`.
     As outras (vitrine) nao sao trocadas, entao a posicao e a do proprio elemento. */
  function daGrade(trilho) {
    return !!(trilho.closest && trilho.closest("#ProductGridContainer"));
  }

  /* depois de cada troca (e na carga): devolve a posicao e garante a ativa a vista */
  function acomodarUm(trilho) {
    var posicao = daGrade(trilho) ? rolagem : trilho.scrollLeft;
    meioCorte(trilho);
    if (trilho.scrollWidth > trilho.clientWidth) {
      trilho.scrollLeft = posicao;
      var ativa = trilho.querySelector(".md-tipos__pilula--ativa");
      if (ativa) {
        var ini = ativa.offsetLeft - trilho.offsetLeft;
        var fim = ini + ativa.offsetWidth;
        if (ini < trilho.scrollLeft || fim > trilho.scrollLeft + trilho.clientWidth) {
          trilho.scrollLeft = Math.max(0, ini - (trilho.clientWidth - ativa.offsetWidth) / 2);
        }
      }
    }
    if (daGrade(trilho)) rolagem = trilho.scrollLeft;
    marcarBordas(trilho);
  }

  function acomodar() {
    var trilhos = document.querySelectorAll("[data-md-tipos]");
    for (var i = 0; i < trilhos.length; i++) acomodarUm(trilhos[i]);
  }

  document.addEventListener("click", function (e) {
    var pilula = e.target.closest ? e.target.closest("[data-md-tipo-param]") : null;
    if (!pilula) return;
    if (pilula.closest("[data-md-tipos-local]")) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var Form = formulario();
    /* sem o facets.js (ou sem grade), o link segue normal e a pagina recarrega filtrada */
    if (!Form || typeof Form.renderPage !== "function" || !document.getElementById("product-grid")) return;
    e.preventDefault();

    var trilho = pilula.closest("[data-md-tipos]");
    var ativa = pilula.classList.contains("md-tipos__pilula--ativa");
    var params = new URLSearchParams(window.location.search);

    var tirar = ativa ? [pilula] : trilho.querySelectorAll(".md-tipos__pilula--ativa");
    for (var i = 0; i < tirar.length; i++) {
      params = semPar(params, tirar[i].dataset.mdTipoParam, tirar[i].dataset.mdTipoValor);
    }
    if (!ativa) params.append(pilula.dataset.mdTipoParam, pilula.dataset.mdTipoValor);
    params.delete("page");

    /* resposta imediata no toque; o estado definitivo chega com o HTML novo */
    var marcadas = trilho.querySelectorAll(".md-tipos__pilula--ativa");
    for (var j = 0; j < marcadas.length; j++) marcadas[j].classList.remove("md-tipos__pilula--ativa");
    if (!ativa) pilula.classList.add("md-tipos__pilula--ativa");
    rolagem = trilho.scrollLeft;

    Form.renderPage(params.toString());
  });

  /* scroll nao borbulha: escuta em captura, a faixa e trocada a cada filtro */
  document.addEventListener(
    "scroll",
    function (e) {
      var alvo = e.target;
      if (alvo && alvo.matches && alvo.matches("[data-md-tipos]")) {
        if (daGrade(alvo)) rolagem = alvo.scrollLeft;
        marcarBordas(alvo);
      }
    },
    true
  );

  /* Arrastar a faixa com o mouse (computador, desde 2026-10-23). O scroller
   * nativo so responde ao dedo, ao trackpad e ao Shift + roda; o mouse comum
   * precisa disto. Mesmo jeito do md-carrossel.js: abaixo de 5px o gesto
   * continua sendo um clique na pilula; acima, e arraste e o clique que vem no
   * fim e engolido (senao soltar o botao em cima de uma pilula aplicaria o
   * filtro). Escuta no document porque a faixa da colecao nasce de novo a
   * cada filtro. Vale para toda faixa [data-md-tipos], inclusive a da vitrine
   * do time na PDP. */
  var arraste = null;
  var engolirClique = false;

  document.addEventListener("pointerdown", function (e) {
    engolirClique = false;
    if (e.pointerType !== "mouse" || e.button !== 0) return;
    var trilho = e.target.closest ? e.target.closest("[data-md-tipos]") : null;
    if (!trilho || trilho.scrollWidth <= trilho.clientWidth + 1) return;
    arraste = { trilho: trilho, x: e.clientX, scroll: trilho.scrollLeft, puxou: false };
  });

  document.addEventListener("pointermove", function (e) {
    if (!arraste) return;
    var dx = e.clientX - arraste.x;
    if (!arraste.puxou) {
      if (Math.abs(dx) < 5) return;
      arraste.puxou = true;
      arraste.trilho.classList.add("md-tipos__trilho--puxando");
    }
    e.preventDefault();
    arraste.trilho.scrollLeft = arraste.scroll - dx;
  });

  function largar() {
    if (!arraste) return;
    arraste.trilho.classList.remove("md-tipos__trilho--puxando");
    if (arraste.puxou) {
      engolirClique = true;
      /* o clique (se vier) chega logo depois do pointerup; passado isso, libera */
      setTimeout(function () {
        engolirClique = false;
      }, 0);
    }
    arraste = null;
  }

  window.addEventListener("pointerup", largar);
  window.addEventListener("pointercancel", largar);

  /* sem isto o navegador entende o gesto como "arrastar o link pra outra janela"
     e para de mandar pointermove no meio do caminho */
  document.addEventListener("dragstart", function (e) {
    if (e.target.closest && e.target.closest("[data-md-tipos]")) e.preventDefault();
  });

  /* em captura na window: roda antes do clique da colecao (acima) e do da
     vitrine (md-vitrine-time.js) */
  window.addEventListener(
    "click",
    function (e) {
      if (!engolirClique) return;
      engolirClique = false;
      if (e.target.closest && e.target.closest("[data-md-tipos]")) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  function iniciar() {
    var grade = document.getElementById("ProductGridContainer");
    if (grade && window.MutationObserver) {
      new MutationObserver(acomodar).observe(grade, { childList: true });
    }
    acomodar();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar);
  else iniciar();
  window.addEventListener("resize", acomodar);
  /* a largura dos rotulos muda quando a fonte da loja termina de carregar */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(acomodar);
  window.addEventListener("load", acomodar);
})();
